import { Injectable, Injector } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { AppSettings } from '@app/common/app-setting';
import { HTTP_INTERCEPTORS, HttpClient, HttpHeaders } from '@angular/common/http';
import { AutharizedEndPointService } from '@app/services/base-service/autharized-endpoint.service';

@Injectable()
export class PaymentForCardEndpoint extends AutharizedEndPointService{
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getPaymentForCardDetailsUrl: string = 'api/CardOperation/PaymentForCard/';

    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
    }

    getUrl(url: string) {
        return this._baseurl + url;
    }
    paymentforcard() {
        return this.http1.get(this.getUrl(this._getPaymentForCardDetailsUrl) , this.AddAuthToken());
    }
}


// WEBPACK FOOTER //
// ./src/app/services/paymentForCard/paymentForCard-endpoint.service.ts